import React from 'react'

export default function InvestorsDB() {
  return (
    <div>InvestorsDB</div>
  )
}
